import React, { useState } from "react";
import { FiChevronDown, FiChevronUp, FiGlobe, FiMessageSquare } from "react-icons/fi";

const faqs = [
  {
    q: "What is Service School House?",
    a: "Service School House is a learning platform that helps participants complete structured learning paths and practical activities.",
  },
  {
    q: "How do I access the Service School House platform?",
    a: "Sign in with your corporate account and open the participant dashboard from the assigned login URL.",
  },
  {
    q: "Who should I contact if I cannot access a module?",
    a: "Use the support email or WhatsApp contact card below and include your name and module title.",
  },
];

const Support = () => {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <div className="max-w-[1200px]">
      <div className="flex items-center gap-2 mb-5">
        <FiMessageSquare className="text-[#0A3059]" />
        <h1 className="text-3xl font-bold text-[#0A3059]">Contact and Support</h1>
      </div>

      <p className="text-gray-700 mb-2">
        We are here to help you. Your satisfaction is our priority, contact us with any questions and concerns.
      </p>
      <p className="text-gray-700 mb-6">
        For live support and personalized assistance, you can reach out directly using the live chat option.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 text-center">
          <FiMessageSquare className="mx-auto text-[#0A3059] text-4xl mb-3" />
          <h2 className="text-2xl font-semibold text-[#0A3059] mb-4">Contact Us</h2>
          <p className="text-gray-700 mb-2">Email: <span className="text-orange-500">support@accesslms.com</span></p>
          <p className="text-gray-700">
            WhatsApp: <a className="text-orange-500" href="https://wa.me/09033854783" target="_blank" rel="noreferrer">https://wa.me/09033854783</a>
          </p>
        </div>

        <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 text-center">
          <FiGlobe className="mx-auto text-[#0A3059] text-4xl mb-3" />
          <h2 className="text-2xl font-semibold text-[#0A3059] mb-4">Live Chat</h2>
          <p className="text-gray-700 mb-3">Our team is available to assist you during business hours.</p>
          <a href="#" className="text-[#0A3059] font-medium underline">Click Here to start a chat.</a>
        </div>
      </div>

      <h3 className="text-2xl font-semibold text-[#0A3059] mb-4 text-center">FAQs</h3>
      <div className="bg-white rounded-xl border border-gray-100 shadow-sm divide-y divide-gray-100">
        {faqs.map((faq, index) => {
          const active = openFaq === index;
          return (
            <button
              type="button"
              key={faq.q}
              onClick={() => setOpenFaq(active ? -1 : index)}
              className="w-full text-left px-5 py-4"
            >
              <div className="flex items-center justify-between gap-4">
                <p className="text-xl text-gray-900">{faq.q}</p>
                {active ? <FiChevronUp /> : <FiChevronDown />}
              </div>
              {active ? <p className="text-sm text-gray-600 mt-3">{faq.a}</p> : null}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Support;
